var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_2821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21H1.50001C0.671548 21 0 20.3284 0 19.5C0 18.6716 0.671548 18 1.50001 18H22.5C23.3285 18 24.0001 18.6716 24.0001 19.5C24 20.3284 23.3285 21 22.5 21Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5H1.50001C0.671548 13.5 0 12.8285 0 12C0 11.1716 0.671548 10.5 1.50001 10.5H22.5C23.3285 10.5 24.0001 11.1716 24.0001 12C24.0001 12.8285 23.3285 13.5 22.5 13.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.99999H1.50001C0.671548 5.99999 0 5.32844 0 4.49998C0 3.67152 0.671548 2.99997 1.50001 2.99997H22.5C23.3285 2.99997 24.0001 3.67152 24.0001 4.49998C24.0001 5.32844 23.3285 5.99999 22.5 5.99999Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.cd1d0552c0fa9f5f3e4286eb60a96f78.svg";
export { ForwardRef as ReactComponent };